"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSumSubLevelVerificationProps = exports.getManualLevel4VerificationProps = exports.getManualLevel3VerificationProps = exports.getManualLevel2VerificationProps = exports.getManualLevel1VerificationProps = exports.getJumioLevel3VerificationProps = exports.getJumioLevel2VerificationProps = exports.getJumioLevel1VerificationProps = exports.getIMLevelVerificationProps = exports.getIMLevel2VerificationProps = exports.getIMLevel1VerificationProps = void 0;
var getIMLevel1VerificationProps = exports.getIMLevel1VerificationProps = function getIMLevel1VerificationProps(verificationLevel, levelIncreaseStatus) {
  return {
    currentLevel: verificationLevel === 0 && levelIncreaseStatus !== 'pass' || verificationLevel === 1 && levelIncreaseStatus === 'underReview'
  };
};
var getIMLevel2VerificationProps = exports.getIMLevel2VerificationProps = function getIMLevel2VerificationProps(verificationLevel, levelIncreaseStatus) {
  return {
    underReview: verificationLevel === 0 && levelIncreaseStatus === 'underReview',
    verified: verificationLevel > 0 || verificationLevel === 0 && levelIncreaseStatus === 'pass',
    canIncrease: verificationLevel === 0 && levelIncreaseStatus !== 'pass' && levelIncreaseStatus !== 'underReview',
    currentLevel: verificationLevel === 1 && levelIncreaseStatus !== 'pass' || verificationLevel === 0 && levelIncreaseStatus === 'pass'
  };
};
var getIMLevelVerificationProps = exports.getIMLevelVerificationProps = function getIMLevelVerificationProps(level, verificationLevel, levelIncreaseStatus) {
  var previousLevel = level - 2; // 0-index.

  return {
    underReview: verificationLevel === previousLevel && levelIncreaseStatus === 'underReview',
    verified: verificationLevel > previousLevel || verificationLevel === previousLevel && levelIncreaseStatus === 'pass',
    canIncrease: verificationLevel === previousLevel - 1 && levelIncreaseStatus === 'pass' || verificationLevel === previousLevel && levelIncreaseStatus !== 'pass' && levelIncreaseStatus !== 'underReview',
    currentLevel: verificationLevel === previousLevel + 1 || verificationLevel === previousLevel && levelIncreaseStatus === 'pass'
  };
};
var getManualLevel1VerificationProps = exports.getManualLevel1VerificationProps = function getManualLevel1VerificationProps(verificationLevel) {
  return {
    currentLevel: verificationLevel === 0
  };
};
var getManualLevel2VerificationProps = exports.getManualLevel2VerificationProps = function getManualLevel2VerificationProps(verificationLevel, levelIncreaseStatus) {
  return {
    underReview: verificationLevel === 0 && levelIncreaseStatus === 1,
    verified: verificationLevel >= 1,
    canIncrease: verificationLevel === 0 && levelIncreaseStatus !== 1,
    currentLevel: verificationLevel === 1
  };
};
var getManualLevel3VerificationProps = exports.getManualLevel3VerificationProps = function getManualLevel3VerificationProps(verificationLevel, levelIncreaseStatus) {
  return {
    underReview: verificationLevel === 1 && levelIncreaseStatus === 2,
    verified: verificationLevel >= 2,
    canIncrease: verificationLevel === 1 && levelIncreaseStatus !== 2,
    currentLevel: verificationLevel === 2
  };
};
var getManualLevel4VerificationProps = exports.getManualLevel4VerificationProps = function getManualLevel4VerificationProps(verificationLevel, levelIncreaseStatus) {
  return {
    underReview: verificationLevel === 2 && levelIncreaseStatus === 3,
    verified: verificationLevel === 3,
    canIncrease: verificationLevel === 2 && levelIncreaseStatus !== 3,
    currentLevel: verificationLevel === 3
  };
};
var getJumioLevel1VerificationProps = exports.getJumioLevel1VerificationProps = function getJumioLevel1VerificationProps() {
  return {
    currentLevel: false
  };
};
var getJumioLevel2VerificationProps = exports.getJumioLevel2VerificationProps = function getJumioLevel2VerificationProps(verificationLevel, levelIncreaseStatus) {
  return {
    underReview: verificationLevel === 0 && levelIncreaseStatus === 'underReview',
    verified: verificationLevel >= 1,
    canIncrease: verificationLevel === 0 && levelIncreaseStatus !== 'underReview',
    currentLevel: verificationLevel === 0
  };
};
var getJumioLevel3VerificationProps = exports.getJumioLevel3VerificationProps = function getJumioLevel3VerificationProps(verificationLevel, levelIncreaseStatus) {
  return {
    underReview: verificationLevel === 1 && levelIncreaseStatus === 'underReview',
    verified: verificationLevel >= 2,
    canIncrease: verificationLevel === 1 && levelIncreaseStatus !== 'underReview',
    currentLevel: verificationLevel === 1
  };
};
var getSumSubLevelVerificationProps = exports.getSumSubLevelVerificationProps = function getSumSubLevelVerificationProps(verificationLevel, subLevel, levelIncreaseStatus) {
  return {
    underReview: verificationLevel === subLevel - 1 && levelIncreaseStatus === 'underReview',
    verified: verificationLevel >= subLevel,
    canIncrease: verificationLevel === subLevel - 1 && levelIncreaseStatus !== 'underReview',
    currentLevel: verificationLevel === subLevel - 1
  };
};